import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

import type { BankAccount } from './types';

type Variables = void;
type Response = BankAccount;

export const useBankAccount = createQuery<Response, Variables, AxiosError>({
  queryKey: ['partner/bank-account'],
  fetcher: () => {
    return client
      .get('v2/internal/partners/bank_accounts')
      .then((response): BankAccount => response.data.data)
      .catch((err: AxiosError): BankAccount => {
        // No account on file yet -- the backend returns 404, which we map to
        // the "none" status so the UI can route to the tutorial/connect flow.
        if (err.response?.status === 404) {
          return { status: 'none' };
        }

        throw err;
      });
  },
});
